import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Divider,
  CircularProgress,
  InputAdornment,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SampleBottleSelectorDialog = ({
  open,
  onClose,
  sampleBottles = [],
  onSelect,
  loading = false,
  title = "Select Sample Bottle",
}) => {
  const [search, setSearch] = useState("");
  const searchRef = useRef(null);

  useEffect(() => {
    if (open) {
      setSearch("");
      setTimeout(() => searchRef.current?.focus(), 100);
    }
  }, [open]);

  const filtered = useMemo(() => {
    const term = search.toLowerCase().trim();
    if (!term) return sampleBottles.slice(0, 50);

    return sampleBottles
      .filter((b) => {
        const name = (b.sampleBottleName || "").toLowerCase();
        const id = (b.recordid || "").toString();
        return name.includes(term) || id.includes(term);
      })
      .slice(0, 50);
  }, [search, sampleBottles]);

  const handleSelect = (item) => {
    onSelect?.(item);
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          size="small"
          value={search}
          inputRef={searchRef}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search sample bottle..."
          sx={{ mb: 2 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress />
          </Box>
        ) : filtered.length === 0 ? (
          <Typography sx={{ textAlign: "center", py: 4 }}>
            No sample bottles found
          </Typography>
        ) : (
          <Paper variant="outlined" sx={{ maxHeight: 350, overflow: "auto" }}>
            <List dense>
              {filtered.map((item, index) => (
                <React.Fragment key={item.recordid}>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleSelect(item)}>
                      <ListItemText
                        primary={item.sampleBottleName}
                        secondary={`ID: ${item.recordid}`}
                      />
                    </ListItemButton>
                  </ListItem>
                  {index < filtered.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Paper>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SampleBottleSelectorDialog;